import {
	allAssetsNotIncludedText,
	getSomeAssetsNotIncludedText,
	singleAssetNotIncludedText,
} from './constants';

export const getConfirmModalText = (notPossibleToAddCount: number, totalAssets: number) => {
	if (notPossibleToAddCount === 1) return singleAssetNotIncludedText;

	if (notPossibleToAddCount > 1 && totalAssets === notPossibleToAddCount) return allAssetsNotIncludedText;

	if (notPossibleToAddCount > 1 && totalAssets !== notPossibleToAddCount)
		return getSomeAssetsNotIncludedText(notPossibleToAddCount);

	return '';
};
